"use server";

import { headers } from "next/headers";
import { getRequestLocale } from "@/lib/request-locale";

const STRAPI_API_URL = process.env.STRAPI_API_URL;

export interface ContactPayload {
  name: string;
  email: string;
  company?: string;
  teamSize?: string;
  interest?: string;
  message: string;
  /** Honeypot — the visible form never fills it. */
  website?: string;
}

export interface ContactResult {
  success: boolean;
  error?: "invalid_input" | "rate_limited" | "mail_failed" | "unavailable";
}

/** Hands the contact form to the backend, which mails it to the support inbox. */
export async function submitContactAction(payload: ContactPayload): Promise<ContactResult> {
  if (!STRAPI_API_URL) return { success: false, error: "unavailable" };
  try {
    const h = await headers();
    const response = await fetch(`${STRAPI_API_URL}/api/saas-contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // The backend rate-limits per visitor, not per Vercel function.
        "x-forwarded-for": h.get("x-forwarded-for") ?? "",
      },
      body: JSON.stringify({
        ...payload,
        locale: await getRequestLocale(),
        page: h.get("referer") ?? "",
      }),
    });
    if (response.ok) return { success: true };
    if (response.status === 429) return { success: false, error: "rate_limited" };
    if (response.status === 400) return { success: false, error: "invalid_input" };
    return { success: false, error: "mail_failed" };
  } catch {
    return { success: false, error: "unavailable" };
  }
}
